var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.6666 26.9999C53.6666 41.7275 41.7276 53.6666 27 53.6666C12.2724 53.6666 0.333313 41.7275 0.333313 26.9999C0.333313 12.2723 12.2724 0.333252 27 0.333252C41.7276 0.333252 53.6666 12.2723 53.6666 26.9999ZM40.4344 16.8988C39.4581 15.9225 37.8752 15.9225 36.8989 16.8988C36.8753 16.9224 36.8531 16.9474 36.8325 16.9736L25.258 31.7224L18.2796 24.744C17.3033 23.7677 15.7203 23.7677 14.744 24.744C13.7677 25.7203 13.7677 27.3032 14.744 28.2795L23.5655 37.101C24.5418 38.0773 26.1247 38.0773 27.1011 37.101C27.1228 37.0793 27.1433 37.0564 27.1625 37.0323L40.4699 20.3982C41.4106 19.4193 41.3987 17.8632 40.4344 16.8988Z",
    fill: "#008055"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarkIcon);
export default __webpack_public_path__ + "static/media/checkmark-icon.7c8163a8db51a60bbcb6d828fa26b5d1.svg";
export { ForwardRef as ReactComponent };